<template>
  <img src="/images/g-logo.png">
</template>

<script>
  export default {
    name: 'GoogleLoginIcon',
  }
</script>
